module.exports = __webpack_public_path__ + "img/pass_left_2.60764943.jpg";